<template>
  <div class="table-borderless">
    <v-simple-table class="cy-client-totals" dense>
      <tbody>
        <TitleRow><span v-t="'Your Details'" /></TitleRow>
        <tr>
          <td><span v-t="'Email'" /></td>
          <td>{{ $store.state.email }}</td>
        </tr>
        <tr>
          <td><span v-t="'Tel'" /></td>
          <td>{{ $store.state.tel }}</td>
        </tr>
      </tbody>
    </v-simple-table>
  </div>
</template>

<script>
import TitleRow from "@/components/totals/TitleRow";
export default {
  components: {
    TitleRow,
  },
};
</script>
